<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('callTimes')">
        <div class="card-panel-icon-wrapper icon-call">
          <el-image style="width:48px;height:48px;" :src="require('../../../assets/images/parking.png')"></el-image>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            车场总数(个)
          </div>
          <count-to :start-val="0" :end-val="this.countData.parkTotal" :duration="10" class="card-panel-num" style="color:#7AEF96"/>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('callTimes')">
        <div class="card-panel-icon-wrapper icon-call">
          <el-image style="width:48px;height:48px;" :src="require('../../../assets/images/call.png')"></el-image>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            呼叫次数(次)
          </div>
          <count-to :start-val="0" :end-val="this.countData.callcount" :duration="10" class="card-panel-num" style="color:#67C23A"/>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('callTimes')">
        <div class="card-panel-icon-wrapper icon-call">
          <el-image style="width:48px;height:48px;" :src="require('../../../assets/images/admin.png')"></el-image>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            管理员数(人)
          </div>
          <count-to :start-val="0" :end-val="this.countData.managerTotal" :duration="10" class="card-panel-num" style="color:#644131"/>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('openTimes')">
        <div class="card-panel-icon-wrapper icon-open">
          <el-image style="width:48px;height:48px;" :src="require('../../../assets/images/car.png')"></el-image>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            开闸数(次)
          </div>
          <count-to :start-val="0" :end-val="this.countData.opencount" :duration="10" class="card-panel-num" style="color:#00C8B8"/>
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('alermTimes')">
        <div class="card-panel-icon-wrapper icon-duijiang">
          <el-image style="width:48px;height:48px;" :src="require('../../../assets/images/warn.png')"></el-image>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            告警数量(次)
          </div>
          <count-to :start-val="0" :end-val="this.countData.alarmcount" :duration="10" class="card-panel-num" style="color:#E96623" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('onlineDevices')">
        <div class="card-panel-icon-wrapper icon-online">
          <el-image style="width:48px;height:48px;" :src="require('../../../assets/images/url.png')"></el-image>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            设备数量(个)
          </div>
          <count-to :start-val="0" :end-val="this.countData.equipcount" :duration="10" class="card-panel-num" style="color:#00E4FD"/>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  props: {
    countData: {
      type: Object,
      required: true
    }
  },
  components: {
    CountTo
  },
  methods: {
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 0px;

  .card-panel-col {
    margin-bottom: 20px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-call {
        background: #dbdbdb;
      }
      .icon-open {
        background: #dbdbdb;
      }
      .icon-online {
        background: #dbdbdb;
      }
      .icon-duijiang {
        background: #dbdbdb;
      }

    }

    .icon-call {
      color: #d81e06;
    }

    .icon-message {
      color: #36a3f7;
    }


    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
